import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

// Icons
import Icon from "../custom-widgets/icon";
// Styles
import styles from "./footer.module.scss";

const MobileFooter = (props) => {
  const data = useStaticQuery(graphql`
    {
      fdic: file(relativePath: { eq: "fdic-equal-housing.png" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            quality: 100
            width: 400
            transformOptions: { cropFocus: CENTER }
            layout: CONSTRAINED
          )
        }
      }
    }
  `);

  function scrollToTop() {
    if (window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }

  return (
    <>
      {props.isSpanish ? (
        <div id="footer-mobile-spanish" className="d-block d-md-none pb-4">
          {/* BACK TO TOP */}
          <div className="text-center border-bottom text-center py-1 mb-5 bg-light">
            <Icon lib="fas" name="sort-up" class="text-gray d-block mx-auto fa-lg" />
            <a
              href="#main-content"
              onClick={(e) => {
                e.preventDefault();
                scrollToTop();
              }}
            >
              Volver arriba
            </a>
          </div>

          {/* SOCIAL ICONS */}
          <p className="d-flex justify-content-center">
            {props.socialLinks.map((item) => (
              <a key={item.id} id={item.id} href={item.url} rel="noopener noreferrer" target="_blank">
                <span className={`mx-2 ${styles.iconWrapper}`}>
                  <Icon {...item.icon} />
                </span>
              </a>
            ))}
          </p>

          {/* LINKS */}
          <div className="container mb-3">
            <div className="row">
              <div className="col-6 border-right">
                <small>
                  <div className="mb-3">
                    <Icon lib="fal" name="lock" class="mr-2 fa-lg" />
                    Iniciar sesión
                  </div>
                  <Link className="d-block" to="/es/banca-personal/entrar">
                    Banca personal
                  </Link>
                </small>
              </div>
              <div className="col-6">
                <small>
                  <div className="mb-3">Enlaces</div>
                  <Link className="d-block" to="/es/terminos-de-uso">
                    Terminos de uso
                  </Link>
                  <Link className="d-block" to="/es/privacidad-y-seguridad">
                    Privacidad y seguridad
                  </Link>
                </small>
              </div>
            </div>
          </div>

          {/* LEGAL */}
          <small className="text-center">
            <p>Routing # 325070980</p>
            <p className="text-muted mx-1">
              WaFd Bank es un DBA (Doing Business As) del Washington Federal Bank, Asociación Nacional.{" "}
            </p>
            <p className="text-muted mx-1">
              &copy; {new Date().getFullYear()}, WaFd Bank, Todos los derechos reservados. Compañía NMLSR #410394
            </p>
          </small>
          <GatsbyImage
            image={data.fdic.childImageSharp.gatsbyImageData}
            className="w-25 mx-auto mt-4 d-block"
            alt="FDIC and Equal Housing Lender logos"
          />
        </div>
      ) : (
        <div id="footer-mobile" className="d-block d-md-none pb-4">
          {/* BACK TO TOP */}
          <div className="text-center border-bottom text-center py-1 mb-5 bg-light">
            <Icon lib="fas" name="sort-up" class="text-gray d-block mx-auto fa-lg" />
            <a
              href="#main-content"
              onClick={(e) => {
                e.preventDefault();
                scrollToTop();
              }}
            >
              Back to Top
            </a>
          </div>

          {/* SOCIAL ICONS */}
          <p className="d-flex justify-content-center">
            {props.socialLinks.map((item) => (
              <a key={item.id} id={item.id} href={item.url} rel="noopener noreferrer" target="_blank">
                <span className={`mx-2 ${styles.iconWrapper}`}>
                  <Icon {...item.icon} />
                </span>
              </a>
            ))}
          </p>

          {/* LINKS */}
          <div className="container mb-3">
            <div className="row">
              <div className="col-6 border-right">
                <small>
                  <div className="mb-3">
                    <Icon lib="fal" name="lock" class="mr-2 fa-lg" />
                    Sign In
                  </div>
                  <Link className="d-block" to="/personal-banking/login">
                    Personal Banking
                  </Link>
                  <Link className="d-block" to="/business-banking/login">
                    WAFD Treasury Express
                  </Link>
                  <Link className="d-block" to="/commercial-banking/login">
                    WAFD Treasury Prime
                  </Link>
                </small>
              </div>
              <div className="col-6">
                <small>
                  <div className="mb-3">Links</div>
                  <Link className="d-block" to="/terms-of-use">
                    Terms of Use
                  </Link>
                  <Link className="d-block" to="/banking-privacy-security">
                    Privacy &amp; Security
                  </Link>
                </small>
              </div>
            </div>
          </div>

          {/* LEGAL */}
          <small className="text-center">
            <p>Routing # 325070980</p>
            <p className="text-muted mx-1">
              WaFd Bank is a DBA (Doing Business As) of Washington Federal Bank, National Association.
            </p>
            <p className="text-muted mx-1">
              &copy; {new Date().getFullYear()}, WaFd Bank, All Rights Reserved. NMLSR Company #410394
            </p>
          </small>
          <GatsbyImage
            image={data.fdic.childImageSharp.gatsbyImageData}
            className="w-25 mx-auto mt-4 d-block"
            alt="FDIC and Equal Housing Lender logos"
          />
        </div>
      )}
    </>
  );
};

export default MobileFooter;
